import { SliderDots } from '@studiometa/ui';

/**
 * Slider component
 */
export default class GalleryDots extends SliderDots {
  paddingSize = 8;
  /**
   * Component Configuration
   */
  static config = {
    name: 'GalleryDots',
    refs: ['wrapper', 'prev', 'next', ...SliderDots.config.refs],
  };

  /**
   *
   */
  mounted() {
    this.currentPosition = 0;
    this.thumbHeight = this.$refs.dots[0].offsetHeight + this.paddingSize;
    this.wrapperHeight = this.$refs.wrapper.parentElement.offsetHeight;

    this.visibleThumbs = Math.ceil(this.wrapperHeight / this.thumbHeight);

    super.mounted();
  }

  /**
   *
   */
  onNextClick() {
    if (this.$refs.dots.length - this.visibleThumbs === this.currentPosition) {
      return;
    }

    this.currentPosition += 1;
    this.$refs.wrapper.style.transform = `translateY(-${this.currentPosition * this.thumbHeight}px)`;
  }

  /**
   *
   */
  onPrevClick() {
    if (this.currentPosition === 0) {
      return;
    }

    this.currentPosition -= 1;

    this.$refs.wrapper.style.transform = `translateY(-${this.currentPosition * this.thumbHeight}px)`;
  }
}
